import {
    LOGIN_SUCCESS,
    LOGIN_ERROR
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case LOGIN_SUCCESS:
          return {
            ...state,
            loginData: action.payload,
          };
        case LOGIN_ERROR:
          return {
            ...state,
            loginError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    